import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { FeaturesView } from './employee-rewards-features.view';

export const Features = (props) => {
  const {
    illustrationFeatures: {
      childImageSharp: { fixed: illustrationFeaturesFixed },
    },
  } = useStaticQuery(graphql`
    query {
      illustrationFeatures: file(
        relativePath: { eq: "pages/employee-rewards/features/map@2x.png" }
      ) {
        childImageSharp {
          fixed(height: 715) {
            ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }
    }
  `);
  return <FeaturesView {...props} illustration={illustrationFeaturesFixed} />;
};
